module.exports = __webpack_public_path__ + "static/media/logo-biblioteca-teresiana-bianco.34d1244e.svg";